module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-comparativus-superlativus.json
// module id = 1300
// module chunks = 129437238620200